module.exports = __webpack_public_path__ + "img/evolve-pic-1.649d4eb2.jpg";